// extracted by mini-css-extract-plugin
export var base = "Hero-module--base--caf7b";
export var innerContainer = "Hero-module--inner-container--7464e";
export var logo = "Hero-module--logo--30e86";
export var projectBaner = "Hero-module--project-baner--5cbe2";